<script lang="ts">
  import { defineComponent } from "vue";
  import FicheObjetMetier from '@/generated/fiches/FicheObjetMetier.vue';
  export default defineComponent({
    extends: FicheObjetMetier,
    components: {}
})
</script>
